module.exports = __webpack_public_path__ + "img/toc.067af580.svg";